import React, { Component } from 'react';
import Dialog, {
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from 'material-ui/Dialog';
import Button from 'material-ui/Button';
import Slide from 'material-ui/transitions/Slide';

function Transition(props) {
  return <Slide direction="up" {...props} />;
}

export default class OptyDialog extends Component {
  state = {
    running: false
  };

  run() {
    this.setState({
      running: true
    })
  }
  render() {
    const { title, text, children, cancelLabel, okLabel, onOK, onClose, okDisabled } = this.props;
    const { running } = this.state;
    const closeAction = () => {
      this.setState({ running: false });
      if (onClose) onClose();
    }

    const okAction = () => {
      if (onOK) onOK();
      closeAction()
    }

    return (
      <Dialog open={running} transition={Transition}>
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <DialogContentText>{text}</DialogContentText>
          {children}
        </DialogContent>
        <DialogActions>
          <Button onClick={closeAction}>
            {cancelLabel || "Cancel"}
          </Button>
          <Button onClick={okAction} disabled={okDisabled} color="primary" autoFocus>
            {okLabel || "Do it!"}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}


// WEBPACK FOOTER //
// ./src/OptyDialog.js